module.exports = __webpack_public_path__ + "static/media/auth-bg.5d0f0ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/auth-bg.jpg
// module id = 1290
// module chunks = 0